import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Skeleton, Tooltip, Typography } from '@mui/material';

const Title = ({ isLoading }) => {
  const [lc, setLc] = useState(null);
  const lcIds = useSelector((state) => state?.classMarking?.dashboard?.lcIds || []);
  const lcId = lcIds[0] || null;
  const lcs = useSelector((state) => state?.class?.unitOfLearning?.lcs || []);
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {});

  useEffect(() => {
    if (lcId) {
      const lc = lcs.find((lc) => lc._id === lcId);
      setLc(lc);
    }
  }, [lcId, lcs]);

  return (
    <div className='flex flex-nowrap items-center h-full w-full gap-1 text-primary-foreground bg-primary '>
      {currentCurriculum?.lcElements?.children
        ?.sort((a, b) => a.position - b.position)
        ?.map((item) => (
          <div className='flex flex-nowrap w-full items-center gap-2 px-2' key={item._id}>
            <Typography
              className='font-bold  bg-primary  min-w-150px max-w-150px text-right'
              color='secondary'
            >
              {item?.name}
            </Typography>
            {isLoading ? (
              <Skeleton width='100%' height='100%' style={{ transform: 'scale(1, 0.96)' }} />
            ) : (
              <div key={`lc-elements-${item._id}-lc-${lc?._id}`}>
                <Tooltip
                  id={`lc-elements-${item._id}-lc-${lc?._id}`}
                  title={lc?.lcElements[item._id]}
                  placement='top'
                  arrow
                >
                  <div
                    className='flex items-center px-2 justify-start cursor-pointer'
                    style={{
                      overflow: 'hidden',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical'
                    }}
                  >
                    {lc?.lcElements[item._id]}
                  </div>
                </Tooltip>
              </div>
            )}
          </div>
        ))}
    </div>
  );
};

export default Title;
